<template>
<el-dialog title="更换题库" :visible.sync="dialogVisible" width="80%" :before-close="handleClose" class="special-change-qb-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="contentLoading" class="special-change-qb-dialog-content">
        <el-table :data="tableData" height="calc(100% - 52px)" highlight-current-row @current-change="handleSelectTable" row-key="innerid" :current-row-key="qbcode">
            <el-table-column prop="subject" label="题库名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qbtype" label="题库类型">
                <template slot-scope="scope">{{scope.row.qbtype === 1 ? '单试卷' : '系列试卷'}}</template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="sizes, prev, pager, next" :total="total" :page-size="pagesize" :current-page="page" @size-change="handlePagesizeChange" @current-change="handlePageChange" :page-sizes="[10, 20, 50, 100]"></el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSetQuestionbankTopicChapter" :loading="loading">确定</el-button>
    </span>
</el-dialog>
</template>
<script>
import {getAllQuestionbankInfo, setQuestionbankTopicChapter} from '@/api/questionApi.js'
export default {
    data() {
        return {
            dialogVisible: false,
            configcode: '',
            qbcode: '',
            contentLoading: false,
            page: 1,
            pagesize: 10,
            total: 0,
            tableData: [],
            loading: false
        }
    },
    methods: {
        handleOpen(configcode) {
            this.configcode = configcode
            this.dialogVisible = true
            this.handleGetAllQuestionbankInfo()
        },
        handleClose() {
            this.dialogVisible = false
            this.contentLoading = false
            this.configcode = ''
            this.qbcode = ''
            this.tableData = []
            this.page = 1
            this.pagesize = 10
        },
        handleGetAllQuestionbankInfo() {
            this.contentLoading = true
            getAllQuestionbankInfo({
                data: {subject: '', status: '', page: this.page, pagesize: this.pagesize},
                success: data => {
                    this.contentLoading = false
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: error => {
                    this.contentLoading = false
                    this.$message.error(error.msg)
                }
            })
        },
        handlePagesizeChange(pagesize) {
            this.pagesize = pagesize
            this.page = 1
            this.handleGetAllQuestionbankInfo()
        },
        handlePageChange(page) {
            this.page = page
            this.handleGetAllQuestionbankInfo()
        },
        handleSelectTable(row) {
            this.qbcode = row.innerid
        },
        handleSetQuestionbankTopicChapter() {
            if (this.qbcode) {
                this.loading = true
                setQuestionbankTopicChapter({
                    data: {qbcode: this.qbcode, configcode: this.configcode},
                    success: data => {
                        this.$message.success('更换成功！')
                        this.handleClose()
                        this.$emit('handleChangeSuccess')
                    },
                    error: error => {
                        this.loading = false
                        this.$message.error(error.msg)
                    }
                })
            } else {
                this.$message.warning('请选择题库！')
            }
        }
    }
}
</script>
<style lang="scss">
.special-change-qb-dialog {
    .el-dialog {
        height: 90vh;
        margin-top: 5vh !important;
        margin-bottom: 5vh !important;
        .el-dialog__body {
            height: calc(90vh - 55px - 72px);
            box-sizing: border-box;
            padding: 0;
            .special-change-qb-dialog-content {
                padding: 10px 20px 0;
                height: 100%;
                box-sizing: border-box;
                .el-table {
                    .el-table__body tr {
                        cursor: pointer;
                        &:hover>td.el-table__cell {
                            background: #ecf5ff;
                        }
                    }
                }
                .el-pagination {
                    text-align: right;
                    .el-pagination__sizes {
                        .el-select {
                            height: 28px;
                            .el-input {
                                height: 28px;
                                .el-input__inner {
                                    height: 28px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .el-dialog__footer {
            padding: 20px;
            .el-button {
                margin-bottom: 0;
            }
        }
    }
}
</style>